var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getErrorMessage)?_c('v-alert',{staticClass:"mx-auto",attrs:{"max-width":"800","value":_vm.getErrorMessage !== null,"type":"error","dismissible":""}},[_vm._v(" "+_vm._s(_vm.getErrorMessage)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }